import React from 'react';
import { Tool } from '../../types';
import ToolCard from '../../components/ToolCard/ToolCard';
import './Dashboard.css';

interface DashboardProps {
  tools: Tool[];
  onSelectTool: (toolId: string) => void;
}

const Dashboard: React.FC<DashboardProps> = ({ tools, onSelectTool }) => {
  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Catelyn Pet Shop Tools</h1>
        <p className="dashboard-subtitle">Select a tool to get started</p>
      </div>
      
      <div className="tools-grid">
        {tools.map((tool) => (
          <ToolCard 
            key={tool.id}
            tool={tool}
            onClick={() => onSelectTool(tool.id)}
          />
        ))}
      </div>
      
      <div className="dashboard-footer">
        <p>More tools coming soon. Need help? Contact support.</p>
      </div>
    </div>
  );
};

export default Dashboard;
